module.exports = __webpack_public_path__ + "static/media/send.384a3d9c.svg";